module.exports = __webpack_public_path__ + "static/media/05 - Real Time B.0a9d3fbc.png";